import { render, staticRenderFns } from "./ReleaseDetailPublic.vue?vue&type=template&id=03c458a1&scoped=true"
import script from "./ReleaseDetailPublic.vue?vue&type=script&lang=js"
export * from "./ReleaseDetailPublic.vue?vue&type=script&lang=js"
import style0 from "./ReleaseDetailPublic.vue?vue&type=style&index=0&id=03c458a1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c458a1",
  null
  
)

export default component.exports